export const HOSTED_FONT_LOAD_TIMEOUT_MS = 15_000;
